export default Object.freeze({
  CONTACT_CREATE_OR_UPDATE: "contact-create-or-update",
  DEAL_UPDATE: "deal-update",
  EVENT_TRIGGER: "event-trigger",
});
